import { Plus, UserPlusIcon } from 'lucide-react'

import { partnersProspects, partnersQuotes } from 'rails_routes'
import { ButtonLink } from 'slab'

import RequestAQuotePanel from './RequestAQuotePanel'

export default function RequestAQuoteButton ({
  isPrimary = true,
  location,
  canSelfServeQuotes,
  prospectId,
} : {
  isPrimary?: boolean,
  location?: string,
  canSelfServeQuotes?: boolean,
  prospectId?: string,
}) {
  if (canSelfServeQuotes) {
    return (
      <ButtonLink
        href={prospectId ? partnersQuotes.new({ prospect_id: prospectId }) : partnersProspects.new()}
        variant={isPrimary ? 'primary' : 'secondary'}
      >
        <div className='flex items-center gap-2'>
          <UserPlusIcon size={21} />
          Create a quote
        </div>
      </ButtonLink>
    )
  }
  return (
    <RequestAQuotePanel
      triggerChildren={
        <button
          className={isPrimary ? 'btn-primary' : 'btn-secondary'}
          onClick={() => {
            window.segment?.track(
              '[TfB] Quote request form opened',
              { location }
            )
          }}
        >
          <Plus size={21} className='mr-2' />
          Request a quote
        </button>
      }
    />
  )
}
